import React, { useState, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Typography, message } from 'antd'

import cashRegisterSrc from '../../cashRegisterSrc'
import { Context } from '../../../../context'

const { Title } = Typography

function StoreCashDrawe(props) {
  const [{ turn }] = useContext(Context)
  const [storeCash, setStoreCash] = useState(null)
  const [reason, setReason] = useState('')
  const [loading, setLoading] = useState(false)

  const onAdjust = () => {
    if (!storeCash || !reason) return message.error('Todos los campos son obligatorios')
    if (isNaN(Number(storeCash))) return message.error('El efectivo en tienda solo puede ser un número')
    if (Number(storeCash) < 0) return message.error('El efectivo en tienda debe ser un monto mayor a cero (0)')

    let data = {
      store_id: props.adjust.id,
      store_turn_id: turn.id,
      amount: storeCash - props.adjust.store_cash,
      description: reason,
    }

    setLoading(true)
    props.setFetch(false)

    cashRegisterSrc
      .newCashAdjustment(data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          Object.keys(res.errors).map(key => {
            switch (key) {
              case 'amount':
                message.error(res.errors[key][0].replace('amount', '¿Cuánto efectivo tiene realmente la tienda?'))
                break
              case 'description':
                message.error(res.errors[key][0].replace('description', '¿Por qué se está ajustando el efectivo?'))
                break
              default:
                message.error(res.errors[key])
                break
            }
            return null
          })

          setLoading(false)
        } else {
          message.success('Se guardo el ajuste correctamente')
          setStoreCash(null)
          setReason('')
          setLoading(false)
          props.closable('save', res.storeId)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('No se pudo guardar el ajuste')
        setLoading(false)
      })
  }

  const onCancel = () => {
    setStoreCash(null)
    setReason('')
    props.closable('cancel')
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
        <div>
          <Title>Ajuste de efectivo</Title>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16} className={'section-space-list'}>
            <Col sm={12}>
              <div className={'title-space-field title-space-top pl-2'}>Efectivo actual en tienda</div>
              <Input value={`Q ${props.adjust.store_cash}`} disabled={true} size={'large'} />
            </Col>
            <Col sm={12}>
              <div className={'title-space-field title-space-top pl-2'}>¿Cuánto efectivo tiene realmente la tienda?</div>
              <Input
                value={storeCash}
                onChange={e => setStoreCash(e.target.value)}
                size={'large'}
                placeholder="Escribe el total del efectivo en tienda"
              />
            </Col>
            <Col sm={24}>
              <div className={'title-space-field title-space-top pl-2'}>¿Por qué se esta ajustando el efectivo?</div>
              <Input
                value={reason}
                onChange={e => setReason(e.target.value)}
                size={'large'}
                placeholder="Escribe la razón por la cual se hace el ajuste"
              />
            </Col>
          </Row>
        </div>
        <div>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  <Button type={'link'} className="cancel-button" onClick={() => onCancel()}>
                    Cancelar
                  </Button>
                  <Button loading={loading} htmlType="submit" className="title-tendero new-button" onClick={onAdjust}>
                    Ajustar
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Drawer>
    </>
  )
}

export default StoreCashDrawe
